import { createContext } from 'react';

const documentContext = createContext({
  document: {},
  setUploadedDocument: () => console.log('not implemented'),
});

export default documentContext;
